(ns practitest.frontend.common.item-card
  (:require [practitest.frontend.common.dom :as dom]))

(defn item-card
  "A flexible item card component.
   Options:
   - :icon - Optional icon element
   - :image - Optional image URL
   - :title - Card title (required)
   - :title-link - Optional link for the title
   - :subtitle - Optional subtitle
   - :description - Optional description text
   - :timestamp - Optional timestamp shown on the right
   - :footer - Optional footer content
   - :on-click - Optional click handler for the entire card
   - :class - Optional additional CSS classes"
  [{:keys [icon image title title-link subtitle description timestamp footer on-click class]} & children]
  [:div.pt-item-card
   {:class (cond-> (dom/classes-pairs-v :clickable on-click)
             class (dom/append-class class))
    :on-click on-click}

   [:div.pt-item-card-content
    (when (or icon image)
      [:div.pt-item-card-left
       (when icon
         [:div.pt-item-card-icon icon])
       (when image
         [:div.pt-item-card-image
          [:img {:src image :alt title}]])])

    [:div.pt-item-card-main
     [:div.pt-item-card-header
      [:div.pt-item-card-title-section
       (when subtitle
         [:div.pt-item-card-subtitle subtitle])
       [:div.pt-item-card-title-wrapper
        (if title-link
          [:a.pt-item-card-title-link {:href title-link} title]
          [:span.pt-item-card-title title])]]

      (when timestamp
        [:div.pt-item-card-right
         [:div.pt-item-card-timestamp timestamp]])]

     (when description
       [:div.pt-item-card-description description])

     (when footer
       [:div.pt-item-card-footer footer])

     children]]])
